import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import MainLayout from './components/layout/MainLayout';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AboutUsPage from './pages/AboutUsPage';
import { CookiesProvider } from 'react-cookie';
import I18NProvider from './i18n/i18nprovider';
import AccreditationPage from './pages/AccreditationPage';
import ElectronicsPage from './pages/ElectronicsPage';
import TelecommunicationsPage from './pages/TelecommunicationsPage';
import EnergyEfficiencyPage from './pages/EnergyEfficiencyPage';
import ProcessOfCertificationPage from './pages/ProcessOfCertification';
import PublicInfoPage from './pages/PublicInfoPage';
import FaqPage from './pages/FaqPage';
import WebinarsPage from './pages/WebinarsPage';
import NewsPage from './pages/NewsPage';
import ComplaintsAppealsPage from './pages/ComplaintsAppealsPage';
import MeetUsPage from './pages/MeetUsPage';
import NOM_001_SCFI_2018 from './pages/NOM/NOM-001-SCFI-2018';
import NOM_016_SCFI_1993 from './pages/NOM/NOM-016-SCFI-1993';
import NOM_019_SCFI_1998 from './pages/NOM/NOM-019-SCFI-1998';
import NOM_196_SCFI_2016 from './pages/NOM/NOM-196-SCFI-2016';
import NOM_218_SCFI_2017 from './pages/NOM/NOM-218-SCFI-2017';
import NOM_208_SCFI_2016 from './pages/NOM/NOM-208-SCFI-2016';
import NOM_003_SCFI_2014 from './pages/NOM/NOM-003-SCFI-2014';
import NOM_221_2_SCFI_2018 from './pages/NOM/NOM-221_2-SCFI-2018';
import IFT_011_2022_PT_3 from './pages/NOM/IFT-011-2022-PT-3';
import IFT_012_2019 from './pages/NOM/IFT-012-2019';
import NOM_221_SCFI_2017 from './pages/NOM/NOM-221-SCFI-2017';
import NOM_029_ENER_2017 from './pages/NOM/NOM_029_ENER_2017';
import NOM_032_ENER_2013 from './pages/NOM/NOM_032_ENER_2013';
import POCElectronics from './pages/POCElectronics';
import POCTelecom from './pages/POCTelecom';
import PISecureElectronics from './pages/PISecureElectronics';
import PIEnergyEfficiency from './pages/PIEnergyEfficiency';
import PITelecom from './pages/PITelecom';
import PIListLabs from './pages/PIListLabs';
import PILegalRegistration from './pages/PILegalReg';
import PICustoms from './pages/PICustoms';
import IFT_015_2018 from './pages/NOM/IFT-015-2018';
import IFT_016_2024 from './pages/NOM/IFT-016-2024';
import IFT_017_2023 from './pages/NOM/IFT-017-2023';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },{
    path: '/about-us',
    element: <AboutUsPage />
  },{
    path: '/accreditation',
    element: <AccreditationPage />
  },{
    path: '/certification-services/electronics',
    element: <ElectronicsPage />
  },{
    path: '/certification-services/telecommunications',
    element: <TelecommunicationsPage />
  },{
    path: '/certification-services/energy-efficiency',
    element: <EnergyEfficiencyPage />
  },{
    path: '/certification-services/process-of-certification',
    element: <ProcessOfCertificationPage />
  },{
    path: '/certification-services/process-of-certification/electronics',
    element: <POCElectronics />
  },{
    path: '/certification-services/process-of-certification/telecom',
    element: <POCTelecom />
  },{
    path: '/general-info/public-info',
    element: <PublicInfoPage />
  },{
    path: '/general-info/public-info/electronic-security',
    element: <PISecureElectronics />
  },{
    path: '/general-info/public-info/energy-efficiency',
    element: <PIEnergyEfficiency />
  },{
    path: '/general-info/public-info/telecommunications',
    element: <PITelecom />
  },{
    path: '/general-info/public-info/list-of-labs',
    element: <PIListLabs />
  },{
    path: '/general-info/public-info/legal-list',
    element: <PILegalRegistration />
  },{
    path: '/general-info/public-info/customs',
    element: <PICustoms />
  },{
    path: '/general-info/faq',
    element: <FaqPage />
  },{
    path: '/general-info/webinars',
    element: <WebinarsPage />
  },{
    path: '/news',
    element: <NewsPage />
  },{
    path: '/news/official-nom',
    element: <NewsPage articleType="official_news" />
  },{
    path: '/news/industry-updates',
    element: <NewsPage articleType="industry_updates" />
  },{
    path: '/news/mcb-updates',
    element: <NewsPage articleType="mcb_updates" />
  },{
    path: '/contact/complaints-appeals',
    element: <ComplaintsAppealsPage />
  },{
    path: '/contact/meet-us',
    element: <MeetUsPage />
  },{
    path: '/NOM/NOM-001-SCFI-2018',
    element: <NOM_001_SCFI_2018 />
  },{
    path: '/NOM/NOM-016-SCFI-1993',
    element: <NOM_016_SCFI_1993 />
  },{
    path: '/NOM/NOM-019-SCFI-1998',
    element: <NOM_019_SCFI_1998 />
  },{
    path: '/NOM/NOM-003-SCFI-2014',
    element: <NOM_003_SCFI_2014 />
  },{
    path: '/telecommunications/NOM-196-SCFI-2016',
    element: <NOM_196_SCFI_2016 />
  },{
    path: '/telecommunications/NOM-218-SCFI-2017',
    element: <NOM_218_SCFI_2017 />
  },{
    path: '/telecommunications/NOM-208-SCFI-2016',
    element: <NOM_208_SCFI_2016 />
  },{
    path: '/telecommunications/NOM-221-SCFI-2017',
    element: <NOM_221_SCFI_2017 />
  },{
    path: '/telecommunications/NOM-221_2-SCFI-2018',
    element: <NOM_221_2_SCFI_2018 />
  },{
    path: '/telecommunications/IFT-011-2022',
    element: <IFT_011_2022_PT_3 />
  },{
    path: '/telecommunications/IFT-012-2019',
    element: <IFT_012_2019 />
  },{
    path: '/telecommunications/IFT-011-2022',
    element: <IFT_011_2022_PT_3 />
  },{
    path: '/telecommunications/IFT-015-2018',
    element: <IFT_015_2018 />
  },{
    path: '/telecommunications/IFT-016-2024',
    element: <IFT_016_2024 />
  },{
    path: '/telecommunications/IFT-017-2023',
    element: <IFT_017_2023 />
  },{
    path: '/energy-efficiency/NOM-029-ENER-2017',
    element: <NOM_029_ENER_2017 />
  },{
    path: '/energy-efficiency/NOM-032-ENER-2013',
    element: <NOM_032_ENER_2013 />
  },
  
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <I18NProvider>
        <MainLayout>
          <RouterProvider router={router} />
        </MainLayout>
      </I18NProvider>
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
